import React, { useMemo, useState } from "react";

import { PageLoader } from "clearsense-ui/components";
import { EmptyState } from "components/Common";
import useJobResultData from "hooks/useJobResultData";

import ChartModal from "./ChartModal";
import { createModelDriverNodeMap, createModelGraphNodeMap } from "./data";
import DistributionTable from "./DistributionTable";
import GraphContainer from "./GraphContainer";

const ModelGraph = ({ isLoading, jobDetails, outputs, setOutputs }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNode, setSelectedNode] = useState();

  const { data: modelGraph, loading: modelGraphLoading } = useJobResultData(
    outputs,
    setOutputs,
    "binary_model_model_graph"
  );

  const { data: modelDrivers, loading: modelDriversLoading } = useJobResultData(
    outputs,
    setOutputs,
    "binary_model_drivers"
  );

  const modelGraphNodeMap = useMemo(
    () => createModelGraphNodeMap(modelGraph) || {},
    [modelGraph]
  );

  const modelDriversNodeMap = useMemo(
    () => createModelDriverNodeMap(modelDrivers) || {},
    [modelDrivers]
  );

  if (isLoading || modelGraphLoading || modelDriversLoading) {
    return <PageLoader />;
  } else if (!jobDetails || !modelGraph) {
    return <EmptyState />;
  }

  return (
    <div className="flex flex-col">
      <GraphContainer
        jobDetails={jobDetails}
        modelGraph={modelGraph}
        modelGraphNodeMap={modelGraphNodeMap}
        setSelectedNode={setSelectedNode}
      />
      <DistributionTable
        modelGraphNodeMap={modelGraphNodeMap}
        modelDriverNodeMap={modelDriversNodeMap}
        node={selectedNode}
        openChartModal={() => setIsModalOpen(true)}
      />
      <ChartModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        outputs={outputs}
        setOutputs={setOutputs}
        modelDrivers={modelDrivers}
        node={selectedNode}
      />
    </div>
  );
};

export default ModelGraph;
